import type { MeiliIndex } from "@/generated/fastapi";

export const SEARCH_PAGE_VIEW_BACKLOG_EXTRACT = "backlog_extract" as const;
export const SEARCH_PAGE_VIEW_STUDIO_CHECK = "studio_check" as const;
export const SEARCH_PAGE_VIEW_STUDIO_SELECT = "studio_select" as const;
export const SEARCH_PAGE_VIEW_STUDIO_PRINT = "studio_print" as const;

export const SEARCH_PAGE_VIEWS = [
  SEARCH_PAGE_VIEW_BACKLOG_EXTRACT,
  SEARCH_PAGE_VIEW_STUDIO_CHECK,
  SEARCH_PAGE_VIEW_STUDIO_SELECT,
  SEARCH_PAGE_VIEW_STUDIO_PRINT,
] as const;

export type SearchPageView = (typeof SEARCH_PAGE_VIEWS)[number];

export const SEARCH_STATE_KEY_BACKLOG = "backlog" as const;
export const SEARCH_STATE_KEY_CHECK = "check" as const;
export const SEARCH_STATE_KEY_SELECT = "select" as const;

export const SEARCH_STATE_KEYS = [
  SEARCH_STATE_KEY_BACKLOG,
  SEARCH_STATE_KEY_CHECK,
  SEARCH_STATE_KEY_SELECT,
] as const;

export type SearchStateKey = (typeof SEARCH_STATE_KEYS)[number];

export const MEILI_INDEX_ORIGINS = "origins" as const;
export const MEILI_INDEX_SUGGESTED_THOUGHTS = "suggested_thoughts" as const;
export const MEILI_INDEX_THOUGHTS = "thoughts" as const;

export const MEILI_INDEXES = [
  MEILI_INDEX_ORIGINS,
  MEILI_INDEX_SUGGESTED_THOUGHTS,
  MEILI_INDEX_THOUGHTS,
] as const satisfies readonly MeiliIndex[];

// NOTE: this excludes MeiliSituation from being user in Next/FE
export type SearchIndexName = (typeof MEILI_INDEXES)[number];

export const SEARCH_SORT_NEWEST = "Newest" as const;
export const SEARCH_SORT_OLDEST = "Oldest" as const;

export const SEARCH_HITS_PER_PAGE_5 = { value: "5", label: "5 per page" };
export const SEARCH_HITS_PER_PAGE_10 = { value: "10", label: "10 per page" };
export const SEARCH_HITS_PER_PAGE_20 = { value: "20", label: "20 per page" };
export const SEARCH_HITS_PER_PAGE_50 = { value: "50", label: "50 per page" };
export const SEARCH_HITS_PER_PAGE_100 = { value: "100", label: "100 per page" };
export const SEARCH_HITS_PER_PAGE_250 = { value: "250", label: "250 per page" };
export const SEARCH_HITS_PER_PAGE_500 = { value: "500", label: "500 per page" };

export const SEARCH_HITS_PER_PAGE_OPTIONS = [
  SEARCH_HITS_PER_PAGE_5,
  SEARCH_HITS_PER_PAGE_10,
  SEARCH_HITS_PER_PAGE_20,
  SEARCH_HITS_PER_PAGE_50,
  SEARCH_HITS_PER_PAGE_100,
  SEARCH_HITS_PER_PAGE_250,
  SEARCH_HITS_PER_PAGE_500,
] as const;
